import { useDrop } from 'react-dnd';
import { defaultTemplate } from 'core/hoc';
import React from 'react';
import _ from 'lodash';

const BaasicDragAndDropTemplate = ({ dropBox, onCanDropCallback, onDropCallback, dragAndDropField, children, key }) => {
	const [{ isOver }, drop] = useDrop(() => ({
		accept: dragAndDropField,
		canDrop: item => onCanDropCallback(dropBox, item.currentDropBox),
		drop: item => onDropCallback(item.dragAndDropField, dropBox, item.currentDropBox),
		collect: monitor => ({
			isOver: !!monitor.isOver(),
		}),
	}));
	return (
		<div ref={drop} key={key}>
			{children}
		</div>
	);
};

export default defaultTemplate(BaasicDragAndDropTemplate);



// WEBPACK FOOTER //
// ./src/themes/default/components/BaasicDragAndDropTemplate.js